/*eslint-disable*/
import { Box, Button, TextField, InputLabel } from "@mui/material";
import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { EditScheduleDet } from "../../../../api/AuthenticationServices";

const EditSchedules = (params) => {
  const location = useLocation();
  const scheduleDetails = location.state?.acrow;
  console.log(scheduleDetails);
  const initialValues = {
    acTitle: scheduleDetails.title,
    acPlace: scheduleDetails.place,
    acDate: scheduleDetails.dateOfAch,
    acOpponent: scheduleDetails.opponent,
    acDescription: scheduleDetails.description,
    acTime: scheduleDetails.time,
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const navigate = useNavigate();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };

  //Sending data
  const sendData = async (e, values) => {
    e.preventDefault();

    try {
      const data = {
        acId: scheduleDetails.id,
        title: values.acTitle,
        place: values.acPlace,
        date: values.acDate,
        description: values.acDescription,
        opponent: values.acOpponent,
        time: values.acTime,
      };

      const res = await EditScheduleDet(data, config);

      if (res.data.status === "success") {
        alert(res.data.message);
        navigate("/admin/viewschedules");
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="Edit SCHEDULE" subtitle="Edit a Schedule" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Title"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acTitle}
                  name="acTitle"
                  error={!!touched.acTitle && !!errors.acTitle}
                  helperText={touched.acTitle && errors.acTitle}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Achievement"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDate}
                  name="acDate"
                  error={!!touched.acDate && !!errors.acDate}
                  helperText={touched.acDate && errors.acDate}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Place"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acPlace}
                  name="acPlace"
                  error={!!touched.acPlace && !!errors.acPlace}
                  helperText={touched.acPlace && errors.acPlace}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Opponent"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acOpponent}
                  name="acOpponent"
                  error={!!touched.acOpponent && !!errors.acOpponent}
                  helperText={touched.acOpponent && errors.acOpponent}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Time"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acTime}
                  name="acTime"
                  error={!!touched.acTime && !!errors.acTime}
                  helperText={touched.acTime && errors.acTime}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDescription}
                  name="acDescription"
                  error={!!touched.acDescription && !!errors.acDescription}
                  helperText={touched.acDescription && errors.acDescription}
                  sx={{ gridColumn: "span 4" }}
                />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Update Schedule
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  acTitle: yup.string().required("required"),
  acDate: yup.string().required("required"),
  acPlace: yup.string().required("required"),
  acOpponent: yup.string().required("required"),
  acDescription: yup.string().required("required"),
  acTime: yup.string().required("required"),
});

export default EditSchedules;
